import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 items-start">

          {/* Company Info */}
          <div className="space-y-2">
            <img
  src="/logo.png"
  alt="Venus Fabcare Logo"
  className="h-12 md:h-16 w-auto"
/>
            <p className="text-gray-300 text-sm leading-relaxed">
              Gentle on fabrics. Tough on stains. Your trusted laundry partner for institutions across India.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-base font-semibold mb-3 text-white">Quick Links</h3>
            <ul className="space-y-1.5">
              <li>
                <Link to="/" className="text-gray-300 hover:text-sky-400 transition-colors text-sm">Home</Link>
              </li>
              <li>
                <Link to="/about" className="text-gray-300 hover:text-sky-400 transition-colors text-sm">About Us</Link>
              </li>
              <li>
                <Link to="/process" className="text-gray-300 hover:text-sky-400 transition-colors text-sm">Our Solution</Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-300 hover:text-sky-400 transition-colors text-sm">Contact Us</Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-base font-semibold mb-3 text-white">Our Services</h3>
            <ul className="space-y-1.5">
              <li>
                <Link to="/services/residential-school" className="text-gray-300 hover:text-sky-400 transition-colors text-sm">Residential School Institutions</Link>
              </li>
              <li>
                <Link to="/services/pu-laundry" className="text-gray-300 hover:text-sky-400 transition-colors text-sm">Residential PU Colleges & Integrated Coaching Campuses</Link>
              </li>
              <li>
                <Link to="/services/universities-laundry" className="text-gray-300 hover:text-sky-400 transition-colors text-sm">Universities, Medical & Higher Education Institutions</Link>
              </li>
              <li>
                <Link to="/services/industrial-laundry" className="text-gray-300 hover:text-sky-400 transition-colors text-sm">Hospitality & Industrial Institutions</Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-base font-semibold mb-3 text-white">Contact Us</h3>
            <ul className="space-y-2">
              <li className="flex items-start space-x-2 text-sm">
                <MapPin className="h-4 w-4 text-sky-400 flex-shrink-0 mt-0.5" />
                <span className="text-gray-300">Bangalore and Moodbidre, Karnataka, India</span>
              </li>
              <li className="flex items-center space-x-2 text-sm">
                <Phone className="h-4 w-4 text-sky-400 flex-shrink-0" />
                <span className="text-gray-300">+91 90357 00656</span>
              </li>
              <li className="flex items-center space-x-2 text-sm">
                <Mail className="h-4 w-4 text-sky-400 flex-shrink-0" />
                <span className="text-gray-300">info@venusfabcare.com</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-700 mt-5 pt-4">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-2 md:space-y-0">
            <p className="text-gray-400 text-xs">
              © 2024 Venus Fabcare. All rights reserved.
            </p>
            <div className="flex space-x-6 text-xs">
              <a href="#" className="text-gray-400 hover:text-sky-400 transition-colors">Privacy Policy</a>
              <a href="#" className="text-gray-400 hover:text-sky-400 transition-colors">Terms of Service</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;